export const PALLET_TYPES = {
  EU_PALLET: 'EU',
  US_PALLET: 'US',
  CUSTOM_PALLET: 'SP',
  EU_EQUIVALENT: 'Eu',
  US_EQUIVALENT: 'Us'
};

export const EXTRAS = {
  LIFTGATE: 'LIFTGATE',
  SIDE_LOAD: 'SIDE_LOAD',
  TOP_LOAD: 'TOP_LOAD',
  HANDLING_LOADING: 'HANDLING_LOADING',
  HANDLING_UNLOADING: 'HANDLING_UNLOADING',
  HANDLING: 'HANDLING'
};

export const JOB_STATES = {
  ASSIGNED: 'assigned',
  PENDING: 'pending',
  DONE: 'done',
  IN_TRANSIT: 'inTransit',
  IN_PROGRESS: 'inProgress',
  CANCELLED: 'cancelled',
  DONE_WITHOUT_MANIFEST: 'doneWithoutManifest',
  DONE_WITH_CANCELLATIONS: 'doneWithCancellations',
  ONROUTE_PICKUP: 'onRoutePickup',
  PENDING_PICKUP: 'pendingPickup',
  LOADED: 'loaded',
  ONROUTE_DROPOFF: 'onRouteDropoff',
  PENDING_DROPOFF: 'pendingDropoff',
  DELIVERED: 'delivered',
  MANIFESTED: 'manifested'
};

export const JOB_STATES_CONS = {
  ASSIGNED: 'ASSIGNED',
  PENDING: 'PENDING',
  DONE: 'DONE',
  IN_TRANSIT: 'IN_TRANSIT',
  IN_PROGRESS: 'IN_PROGRESS',
  CANCELLED: 'CANCELLED',
  DONE_WITHOUT_MANIFEST: 'DONE_WITHOUT_MANIFEST',
  DONE_WITH_CANCELLATIONS: 'DONE_WITH_CANCELLATIONS',
  ONROUTE_PICKUP: 'ONROUTE_PICKUP',
  PENDING_PICKUP: 'PENDING_PICKUP',
  LOADED: 'LOADED',
  ONROUTE_DROPOFF: 'ONROUTE_DROPOFF',
  PENDING_DROPOFF: 'PENDING_DROPOFF',
  DELIVERED: 'DELIVERED',
  MANIFESTED: 'MANIFESTED'
};

export const STOP_STATES = {
  ONROUTE_DROPOFF: 'ONROUTE_DROPOFF',
  PENDING_DROPOFF: 'PENDING_DROPOFF',
  DELIVERED: 'DELIVERED',
  ONROUTE_PICKUP: 'ONROUTE_PICKUP',
  PENDING_PICKUP: 'PENDING_PICKUP',
  LOADED: 'LOADED'
};

export const STOP_ACTIONS = {
  ONROUTE_PICKUP_ACTION: 'ONROUTE_PICKUP_ACTION',
  PENDING_PICKUP_ACTION: 'PENDING_PICKUP_ACTION',
  LOADED_ACTION: 'LOADED_ACTION',
  ONROUTE_DROPOFF_ACTION: 'ONROUTE_DROPOFF_ACTION',
  PENDING_DROPOFF_ACTION: 'PENDING_DROPOFF_ACTION',
  DELIVERED_ACTION: 'DELIVERED_ACTION'
};

export const BADGE_COLOR_STATES = {
  ASSIGNED: 'grey',
  DONE: 'blue',
  IN_TRANSIT: 'green',
  IN_PROGRESS: 'green',
  PENDING: 'red',
  DONE_WITHOUT_MANIFEST: 'blue',
  DONE_WITH_CANCELLATIONS: 'grey',
  CANCELLED: 'grey',
  ONROUTE_PICKUP: 'green',
  PENDING_PICKUP: 'green',
  LOADED: 'blue',
  ONROUTE_DROPOFF: 'green',
  PENDING_DROPOFF: 'green',
  DELIVERED: 'red',
  MANIFESTED: 'blue'
};

export const POD_STATES = {
  PENDING: 'pending',
  DONE: 'uploaded'
};
